(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldSelect', ['thfFieldHelper','$sce', function(thfFieldHelper, $sce) {
        var link = function(scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');

            $('select', el).selectpicker({
                noneSelectedText: "Please select", template: {
                    caret: '<span class="caret">' +
                    '<svg class="icon icon-closed" viewBox="'+scope.formState.icon.up.viewBox+'"><use xlink:href="'+scope.formState.icon.up.src+'"></use></svg>' +
                    '<svg class="icon icon-open" viewBox="'+scope.formState.icon.down.viewBox+'"><use xlink:href="' + scope.formState.icon.down.src+ '"></use></svg>' +
                    '</span>'
                }
            });

            scope.$watchGroup([
                'model.'+scope.field.name,
                'field.options'
            ], function() {
                thfFieldHelper.debugLog('Select', 'watch');
                $('select', el).selectpicker('refresh');
            }, true);
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/select.html');
            }
        };
    }]);
})(jQuery, angular, window);
